<template>
  <div>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-card v-else>
      <v-card-title>
        <v-tabs v-model="tab">
          <v-tab>Datos</v-tab>
          <v-tab>Caracteristicas</v-tab>
          <v-tab v-if="esAdmin">Costos</v-tab>
          <v-tab v-if="esAdmin" @click="obtenerIngresosEgresos"
            >Ingresos y Egresos</v-tab
          >
        </v-tabs>
        <v-spacer></v-spacer>
        <v-btn color="red" fab absolute right small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row>
              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="4"
                    ><v-text-field
                      label="Codigo"
                      required
                      v-model="producto.codigo"
                      :error-messages="errorCodigo"
                      @input="$v.producto.codigo.$touch()"
                      @blur="$v.producto.codigo.$touch()"
                    ></v-text-field
                  ></v-col>
                  <v-col cols="8"
                    ><v-text-field
                      label="Nombre"
                      required
                      v-model="producto.nombre"
                      :error-messages="errorNombre"
                      @input="$v.producto.nombre.$touch()"
                      @blur="$v.producto.nombre.$touch()"
                    ></v-text-field
                  ></v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-autocomplete
                      v-model="producto.iva"
                      label="IVA"
                      :items="valoresIVA"
                      suffix="%"
                      :error="$v.producto.iva.$error"
                      @input="$v.producto.iva.$touch()"
                      @blur="$v.producto.iva.$touch()"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="8">
                    <v-combobox
                      v-model="producto.categoria"
                      :items="categorias"
                      label="Categoria"
                      :error-messages="errorCategoria"
                      :search-input.sync="busquedaCategoria"
                      @input="$v.producto.categoria.$touch()"
                      @blur="$v.producto.categoria.$touch()"
                      item-text="nombre"
                      item-value="_id"
                      ><template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              No existe la categoría
                              <strong>{{ busquedaCategoria }}</strong
                              >. Presione <kbd>enter</kbd> para crearla.
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-combobox></v-col
                  >
                </v-row>
                <h5>Ubicación en depósito</h5>
                <v-row>
                  <v-col cols="6"
                    ><v-select
                      label="Columna"
                      :items="abecedario"
                      v-model="producto.almacen.columna"
                    ></v-select
                  ></v-col>
                  <v-col cols="6"
                    ><v-text-field
                      label="Fila"
                      v-model="producto.almacen.fila"
                      type="number"
                    ></v-text-field
                  ></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              Precio
                            </th>
                            <th class="text-left">
                              Cantidad minima
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in producto.precios"
                            :key="index"
                          >
                            <td>
                              <v-text-field
                                prefix="$"
                                v-model="item.precio"
                                :disabled="!esAdmin"
                              ></v-text-field>
                            </td>
                            <td>
                              <v-text-field
                                suffix="u"
                                v-model="item.cantidad"
                                :disabled="!esAdmin"
                              ></v-text-field>
                            </td>
                            <td>
                              <v-btn
                                color="red"
                                @click="quitarPrecio(index)"
                                icon
                                v-if="esAdmin && producto.precios.length > 1"
                                ><v-icon>mdi-minus</v-icon></v-btn
                              >
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-btn
                      text
                      v-if="esAdmin"
                      block
                      color="green"
                      @click="agregarPrecio()"
                      ><v-icon>mdi-plus</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="8">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          type="number"
                          label="Stock"
                          disabled
                          suffix="u."
                          v-model="producto.stock"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          type="number"
                          label="Alerta de stock minimo"
                          suffix="u."
                          v-model="producto.stockMinimo"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-text-field
                      label="Slug"
                      v-model="producto.slug"
                      :error="$v.producto.slug.$error"
                      @input="$v.producto.slug.$touch()"
                      @blur="$v.producto.slug.$touch()"
                    ></v-text-field>
                    <v-textarea
                      label="Descripcion"
                      v-model="producto.descripcion"
                    ></v-textarea>
                    <v-checkbox
                      v-model="producto.destacado"
                      label="Producto destacado"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="producto.ocultarTienda"
                      label="Ocultar de la Tienda"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-img v-if="this.foto != ''" :src="this.foto"></v-img>
                    <v-file-input
                      accept="image/png, image/jpeg, image/bmp"
                      prepend-icon="mdi-camera"
                      label="Foto"
                      @change="cambiarFoto"
                      show-size
                    ></v-file-input>
                    <span class="red--text">{{ fotoError }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-btn
              block
              :color="verificarFormulario ? 'error' : 'success'"
              @click="guardarProducto()"
            >
              <v-icon left>
                {{ verificarFormulario ? "mdi-close" : "mdi-check" }} </v-icon
              >Guardar Producto
            </v-btn>
            <p
              class="text-right red--text mt-2"
              @click="bajaProducto()"
              :disabled="loading"
            >
              <v-icon color="red">mdi-delete</v-icon> Dar de baja producto
            </p>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Peso"
                  v-model="producto.medidas.peso"
                  suffix="kg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-row class="mt-n3">
                  <v-col
                    ><v-text-field
                      v-model="producto.medidas.volumen.x"
                      suffix="cm"
                      label="Volumen ancho"
                    ></v-text-field
                  ></v-col>
                  <v-col
                    ><v-text-field
                      v-model="producto.medidas.volumen.y"
                      suffix="cm"
                      label="largo"
                    ></v-text-field
                  ></v-col>
                  <v-col
                    ><v-text-field
                      v-model="producto.medidas.volumen.z"
                      suffix="cm"
                      label="alto"
                    ></v-text-field
                  ></v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Caracteristica
                    </th>
                    <th class="text-left">
                      Valor
                    </th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in producto.caracteristicas"
                    :key="index"
                  >
                    <td>{{ parseCaract(item.caracteristica) }}</td>
                    <td>{{ item.valor }}</td>
                    <td>
                      <v-btn icon @click="editarCaracteristica(index)"
                        ><v-icon>mdi-pencil</v-icon></v-btn
                      ><v-btn icon @click="borrarCaracteristica(index)"
                        ><v-icon>mdi-delete</v-icon></v-btn
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <v-combobox
                        v-model="caracteristica.caracteristica"
                        :items="caracteristicas"
                        :search-input.sync="busquedaCaracteristica"
                        :error="$v.caracteristica.caracteristica.$error"
                        @input="$v.caracteristica.caracteristica.$touch()"
                        @blur="$v.caracteristica.caracteristica.$touch()"
                        item-text="nombre"
                        item-value="_id"
                        ><template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                No existe la caracteristica
                                <strong>{{ busquedaCaracteristica }}</strong
                                >. Presione <kbd>enter</kbd> para crearla.
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template></v-combobox
                      >
                    </td>
                    <td>
                      <v-text-field
                        v-model="caracteristica.valor"
                        :error="$v.caracteristica.valor.$error"
                        @input="$v.caracteristica.valor.$touch()"
                        @blur="$v.caracteristica.valor.$touch()"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-btn
                        icon
                        @click="agregarCaracteristica"
                        :color="verificarCaracteristica ? 'green' : 'red'"
                        ><v-icon>mdi-check</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" md="6">
                <h3>Proveedor</h3>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Fecha y Hora
                        </th>
                        <th class="text-left">
                          Costo por Unidad
                        </th>
                        <th class="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in producto.costosProducto"
                        :key="index"
                      >
                        <td>
                          {{
                            $moment(item.fecha).format(
                              "dddd DD [de] MMMM YYYY H:mm"
                            )
                          }}
                        </td>
                        <td>{{ item.monto }}</td>
                        <td>
                          <v-icon @click="verCompra(item.compra)"
                            >mdi-eye</v-icon
                          >
                        </td>
                      </tr>
                      <tr v-if="!producto.costosProducto.length">
                        <td>Aun no se ingresaron datos</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12" md="6">
                <h3>Transporte</h3>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Fecha y Hora
                        </th>
                        <th class="text-left">
                          Costo por Unidad
                        </th>
                        <th class="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in producto.costosTransporte"
                        :key="index"
                      >
                        <td>
                          {{
                            $moment(item.fecha).format(
                              "dddd DD [de] MMMM YYYY H:mm"
                            )
                          }}
                        </td>
                        <td>{{ item.monto }}</td>
                        <td>
                          <v-icon @click="verCompra(item.compra)"
                            >mdi-eye</v-icon
                          >
                        </td>
                      </tr>
                      <tr v-if="!producto.costosTransporte.length">
                        <td>Aun no se ingresaron datos</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" md="6"
                >
                <v-card class='pa-4 my-2'>
                  <v-icon class='d-inline-flex' color='green'>mdi-arrow-up</v-icon>
                  <h3 class='px-4 d-inline-flex'>Total de Ingresos: {{totalIngresos}}</h3>
                </v-card>
                <v-data-table
                  :headers="headersIngresos"
                  :items="ingresos"
                  item-key="_id"
                  class="elevation-1"
                  :search="buscarIngresos"
                >
                  <template v-slot:top>
                    <v-text-field
                      v-model="buscarIngresos"
                      label="Buscar en Ingresos"
                      class="mx-4"
                    ></v-text-field>
                  </template>
                  <template v-slot:item.fechaAlta="{item}">
                    {{
                     $moment(item.fechaAlta).format(
                        "dddd DD [de] MMMM YYYY H:mm"
                      )
                    }}
                  </template>
                </v-data-table></v-col
              >
              <v-col cols="12" md="6">
                <v-card class='pa-4 my-2'>
                  <v-icon class='d-inline-flex' color='red'>mdi-arrow-down</v-icon>
                  <h3 class='px-4 d-inline-flex'>Total de Egresos: {{totalEgresos}}</h3>
                </v-card><v-data-table
                  :headers="headersEgresos"
                  :items="egresos"
                  item-key="_id"
                  class="elevation-1"
                  :search="buscarEgresos"
                >
                  <template v-slot:top>
                    <v-text-field
                      v-model="buscarEgresos"
                      label="Buscar en Egresos"
                      class="mx-4"
                    ></v-text-field>
                  </template>
                  <template v-slot:item._id="{item}">
                    {{
                     $moment(item._id).format(
                        "dddd DD [de] MMMM YYYY"
                      )
                    }}
                  </template>
                </v-data-table></v-col
              >
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";
const greaterThanZero = (value) => value > 0;
export default {
  name: "Productos_Nuevo",
  data() {
    return {
      tab: 0,
      producto: {
        codigo: "",
        nombre: "",
        precios: [],
        categoria: "",
        descripcion: "",
        destacado: false,
        ocultarTienda: false,
        iva: null,
        costosProducto: [],
        costosTransporte: [],
        caracteristicas: [],
        slug: "",
        medidas: {
          peso: 0,
          volumen: {
            x: 0,
            y: 0,
            z: 0,
          },
        },
        almacen: {
          columna: "",
          fila: 0,
        },
        stock: 0,
        stockMinimo: 0,
      },
      caracteristica: {
        caracteristica: "",
        valor: "",
      },
      busquedaCaracteristica: "",
      caracteristicas: [],
      categorias: [],
      foto: "",
      fotoError: null,
      loading: true,
      busquedaCategoria: "",
      valoresIVA: [21, 10.5, 0],
      ingresos: [],
      totalIngresos: 0,
      buscarIngresos: '',
      headersIngresos: [
        {
          text: "Fecha y Hora",
          align: "start",
          value: "fechaAlta",
        },
        {
          text: "Proveedor",
          value: "proveedor.nombre",
        },
        {
          text: "Cantidad",
          value: "cantidad",
        },
      ],
      egresos: [],
      headersEgresos: [
        {
          text: "Fecha",
          align: "start",
          value: "_id",
        },
        {
          text: "Cantidad",
          value: "cantidad",
        },
      ],
      buscarEgresos: ''
    };
  },
  methods: {
    async obtenerIngresosEgresos() {
      try {
        const ingresos = await axios.get("/mercaderias/ingresos/" + this.id);
        this.ingresos = ingresos.data.ingresosProducto;
        this.totalIngresos = ingresos.data.total
        const egresos = await axios.get("/ventas/producto/" + this.id)
        this.egresos = egresos.data.ventasProducto
        this.totalEgresos = egresos.data.total
      } catch (error) {
        console.log(error);
      }
    },
    cambiarFoto(event) {
      this.foto = "";
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (event) {
        if (!allowedTypes.includes(event.type)) {
          this.fotoError = "El archivo no es una imagen.";
        } else if (event.size > 2000000) {
          this.fotoError =
            "El archivo es muy grande. Seleccione una imagen menor a 2Mb.";
        } else {
          this.fotoError = null;
          const reader = new FileReader();
          reader.readAsDataURL(event);
          reader.onload = (e) => {
            this.foto = e.target.result;
          };
        }
      }
    },
    async guardarProducto() {
      this.$v.producto.$touch();
      if (!this.$v.producto.$invalid) {
        this.loading = true;
        try {
          if (this.foto) this.producto.foto = this.foto;
          await axios.put(`/producto/${this.id}`, this.producto);
          this.cargarProducto();
        } catch (error) {
          console.log(error);
        }
        this.loading = false;
      }
    },
    async bajaProducto() {
      if (this.producto.stock > 0) {
        alert("No se puede dar de baja un producto que tiene stock.");
      } else {
        if (
          confirm(
            `¿Desea dar de baja el producto ${this.producto.nombre}? Esta accion no se puede deshacer.`
          )
        ) {
          this.loading = true;
          try {
            const baja = await axios.delete(`/producto/${this.id}`);
            alert("Se dio de baja al producto.");
            this._cerrar();
          } catch (error) {
            alert(
              "No se pudo dar de baja el producto. Por favor, intente nuevamente."
            );
          }
          this.loading = false;
        }
      }
    },
    async obtenerCategorias() {
      try {
        const categorias = await axios.get("/categorias");
        this.categorias = categorias.data;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerCaracteristicas() {
      try {
        const caracteristicas = await axios.get("/caracteristicas");
        this.caracteristicas = caracteristicas.data;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarProducto() {
      try {
        await this.obtenerCategorias();
        await this.obtenerCaracteristicas();
        const prod = await axios.get(`/producto/${this.id}`);
        this.producto = prod.data;
        this.loading = false;
        if (this.producto.foto != "") this.foto = this.producto.foto;
      } catch (error) {
        this.$router.push(`/productos/`);
      }
    },
    agregarCaracteristica() {
      this.$v.caracteristica.$touch();
      if (!this.$v.caracteristica.$invalid) {
        this.caracteristica.orden = this.producto.caracteristicas.length + 1;
        this.producto.caracteristicas.push(this.caracteristica);
        this.caracteristica = {
          caracteristica: "",
          valor: "",
        };
        this.$v.caracteristica.$reset();
      }
    },
    editarCaracteristica(i) {
      this.caracteristica = this.producto.caracteristicas[i];
      this.borrarCaracteristica(i);
    },
    borrarCaracteristica(i) {
      this.producto.caracteristicas.splice(i, 1);
    },
    parseCaract(c) {
      return c.nombre ? c.nombre : c;
    },
    _cerrar() {
      this.$router.go(-1);
    },
    agregarPrecio() {
      this.producto.precios.push({
        cantidad: 0,
        precio: 0,
      });
    },
    quitarPrecio(i) {
      this.producto.precios.splice(i, 1);
    },
    verCompra(id) {
      this.$router.push("/compras/" + id);
    },
  },
  validations: {
    producto: {
      codigo: { required, minLength: minLength(3) },
      nombre: { required, minLength: minLength(3) },
      categoria: { required },
      iva: { required },
      slug: { required, minLength: minLength(3) },
    },
    caracteristica: {
      caracteristica: { required, minLength: minLength(3) },
      valor: { required, minLength: minLength(3) },
    },
  },
  created() {
    this.cargarProducto();
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    esAdmin() {
      return this.$store.state.datos.roles.includes("superadmin");
    },
    abecedario() {
      return new Array(26).fill(1).map((_, i) => String.fromCharCode(65 + i));
    },
    verificarCaracteristica() {
      return !this.$v.caracteristica.$invalid;
    },
    errorNombre() {
      const errors = [];
      if (!this.$v.producto.nombre.$dirty) return errors;
      !this.$v.producto.nombre.minLength &&
        errors.push("El Nombre debe tener al menos 3 caracteres.");
      !this.$v.producto.nombre.required &&
        errors.push("Debe ingresar un Nombre.");
      return errors;
    },
    errorCodigo() {
      const errors = [];
      if (!this.$v.producto.codigo.$dirty) return errors;
      !this.$v.producto.codigo.minLength &&
        errors.push("El Codigo debe tener al menos 3 caracteres.");
      !this.$v.producto.codigo.required &&
        errors.push("Debe ingresar un Codigo.");
      return errors;
    },
    errorCategoria() {
      const errors = [];
      if (!this.$v.producto.categoria.$dirty) return errors;
      !this.$v.producto.categoria.required &&
        errors.push("Debe ingresar una Categoria.");
      return errors;
    },
    verificarFormulario() {
      let problemaPrecios = this.producto.precios.reduce((f, p) => {
        return this.producto.precios.filter((v) => v.cantidad == 0).length <
          1 ||
          this.producto.precios.filter((v) => v.cantidad == p.cantidad).length >
            1 ||
          !p.precio
          ? true
          : f;
      }, false);
      return problemaPrecios ? true : this.$v.producto.$invalid;
    },
  },
};
</script>
